<template>
  <div>
    <wc-page-title title='Budget Detail' :subtitle='subtitle' :loading='isLoading'>
      <template v-slot:rightSide>
        <v-chip
          small
          color='success'
          label
          v-if='budget && budget.is_active'
        >
          Active Budget
        </v-chip>
      </template>
    </wc-page-title>
    <v-container v-if='budget && budget.archived'>
      <v-alert type='error'>Budget is Archived</v-alert>
    </v-container>
    <router-view
      v-if='budget'
      :budget='budget'
      @update='update'
    ></router-view>
  </div>
</template>

<script>
import budgetsAPI from '@/modules/management/api/budgets'

export default {
  name: 'budget-base',
  data: () => ({
    isLoading: true,
    budget: null
  }),
  computed: {
    subtitle () {
      if (this.budget) {
        return this.budget.description
      }
      return ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.budget = await budgetsAPI.getBudget(this.$route.params.id)
      this.isLoading = false
    },
    async update (obj) {
      this.isLoading = true
      this.budget = await budgetsAPI.updateBudget(obj)
      this.isLoading = false
    }
  }
}
</script>
